import {db} from "@/firebase/init";

export default {
    data () {
        return {
            listener: null
        };
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
    },
    methods: {
        async forcedLogoutSnapShot () {
            try {
                console.log('snapshot call')
                const query = db.collection('users').doc(this.user.uid);
                this.listener = query.onSnapshot((docSnapshot) => {
                    if (!docSnapshot.exists) {
                        console.log('I was called here??');
                        window.location = '/'
                    }
                });
                console.log('snapshot called')
            } catch (e) {
                console.log(e.toString(), 'error occurred in setting up force logout snapshot');
            }
        },
        removeForcedLogoutSnapShotListener () {
            if (this.listener) {
                this.listener();
            }
        }
    }
};
